// Collapsible Tab Enhanced Animation
if (!window.CollapsibleTabAnimator) {
  window.CollapsibleTabAnimator = class CollapsibleTabAnimator {
    constructor(detailsElement) {
      this.details = detailsElement;
      this.summary = detailsElement.querySelector('summary');
      this.content = detailsElement.querySelector('[data-collapsible-content]');
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;

      if (!this.summary || !this.content) return;

      this.init();
    }

    init() {
      this.summary.addEventListener('click', (e) => {
        e.preventDefault();
        this.details.style.overflow = 'hidden';

        if (this.isClosing || !this.details.open) {
          this.open();
        } else if (this.isExpanding || this.details.open) {
          this.shrink();
        }
      });
    }

    open() {
      this.details.style.height = `${this.details.offsetHeight}px`;
      this.details.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
      });

      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    shrink() {
      this.isClosing = true;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    onAnimationFinish(open) {
      this.details.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.details.style.height = this.details.style.overflow = '';
    }
  };

  const initCollapsibleTabs = function () {
    document.querySelectorAll('[data-collapsible-tab]').forEach(function (tab) {
      if (tab.dataset.collapsibleBound === 'true') return;
      tab.dataset.collapsibleBound = 'true';
      new window.CollapsibleTabAnimator(tab);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollapsibleTabs);
  } else {
    initCollapsibleTabs();
  }

  document.addEventListener('shopify:section:load', initCollapsibleTabs);
}
